/* @flow */
/* Do not edit - Generated by iconify. See README.md for more details. */
/* eslint-disable max-len */
import type { ElementConfig as ReactElementConfig } from "react"

import BaseIcon from "./BaseIcon";

export default class SvgIconCross extends BaseIcon {
    static defaultProps: ReactElementConfig<typeof BaseIcon> = {
        iconClass: "CrossIcon",
    }

    svgContent: string = `
        <svg class='${this.classNames}' version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 64 64" enable-background="new 0 0 64 64"  xml:space="preserve"><g><path fill="#231F20"  d="M27.364,38.295c-0.279,0-0.56-0.105-0.773-0.317c-0.432-0.428-0.436-1.124-0.009-1.556 l14.524-14.679c0.429-0.433,1.125-0.436,1.556-0.009c0.432,0.428,0.436,1.124,0.009,1.556L28.146,37.969 C27.931,38.187,27.647,38.295,27.364,38.295z"></path></g><g><path fill="#231F20"  d="M41.966,38.218c-0.279,0-0.56-0.105-0.773-0.317L26.514,23.376 c-0.432-0.428-0.436-1.124-0.009-1.556c0.429-0.432,1.125-0.437,1.556-0.009l14.679,14.524c0.432,0.428,0.436,1.124,0.009,1.556 C42.532,38.109,42.249,38.218,41.966,38.218z"></path></g></svg>
    `;
}
